<template>
    <ul class="o-project-nav-admin">
        <li>
            <router-link
                :to="{
                    name: 'project-main',
                    params: {
                        projectUuid,
                    },
                }"
            >
                <i class="uil uil-cog"></i>
                {{ $t('app.Project') }}
            </router-link>
        </li>
        <li>
            <router-link
                :to="{
                    name: 'project-resources',
                    params: {
                        projectUuid,
                    },
                }"
            >
                <i class="uil uil-package"></i>
                {{ $t('app.Resources') }}
            </router-link>
        </li>
        <li>
            <router-link
                :to="{
                    name: 'project-translations',
                    params: {
                        projectUuid,
                    },
                }"
            >
                <i class="uil uil-schedule"></i>
                {{ $t('app.Translations') }}
            </router-link>
        </li>
        <li>
            <router-link
                :to="{
                    name: 'project-notifs',
                    params: {
                        projectUuid,
                    },
                }"
            >
                <i class="uil uil-message"></i>
                {{ $t('app.Notifs') }}
            </router-link>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'OProjectNavAdmin',
    props: {
        projectUuid: {
            type: String,
            required: true
        },
    }
 }
</script>

<style lang="scss" scoped>
@import 'theme';
</style>
